import { createReducer, createActions } from "reduxsauce";
import IExpense from "../../../interfaces/IExpense";

export const { Types, Creators } = createActions({
    createExpenseRequest: ["payload"],
    createExpenseSuccess: ["payload"],
    createExpenseFailure: [],

    deleteExpenseRequest: ["payload"],
    deleteExpenseSuccess: ["payload"],
    deleteExpenseFailure: [],
});

export interface IExpenseStore {
    isLoading: boolean;
    items: IExpense[];
}

// the initial state of this reducer
export const INITIAL_STATE: IExpenseStore = {
    isLoading: false,
    items: [],
};

export const request = (state = INITIAL_STATE): IExpenseStore => {
    return { ...state, isLoading: true };
};

export const createSuccess = (
    state = INITIAL_STATE,
    action: any
): IExpenseStore => {
    const hasThisExpense = state.items.some(
        (expense) => expense.uuid === action.payload.uuid
    );

    const updateExpenses = hasThisExpense
        ? state.items.map((expense) =>
              expense.uuid === action.payload.uuid ? action.payload : expense
          )
        : [action.payload, ...state.items];

    return {
        ...state,
        isLoading: false,
        items: updateExpenses,
    };
};

export const deleteSuccess = (
    state = INITIAL_STATE,
    action: any
): IExpenseStore => {
    const updateExpenses = state.items.filter(
        (expense) => expense.uuid !== action.payload.uuid
    );

    return {
        ...state,
        isLoading: false,
        items: updateExpenses,
    };
};

export const failure = (state = INITIAL_STATE): IExpenseStore => {
    return { ...state, isLoading: false };
};

// map our action types to our reducer functions

export default createReducer(INITIAL_STATE, {
    [Types.CREATE_EXPENSE_REQUEST as string]: request,
    [Types.CREATE_EXPENSE_SUCCESS as string]: createSuccess,
    [Types.CREATE_EXPENSE_FAILURE as string]: failure,

    [Types.DELETE_EXPENSE_REQUEST as string]: request,
    [Types.DELETE_EXPENSE_SUCCESS as string]: deleteSuccess,
    [Types.DELETE_EXPENSE_FAILURE as string]: failure,
});
